import { render, staticRenderFns } from "./VesselDetail.vue?vue&type=template&id=1ba14e62&"
import script from "./VesselDetail.vue?vue&type=script&lang=js&"
export * from "./VesselDetail.vue?vue&type=script&lang=js&"
import style0 from "./VesselDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports